import React, {Suspense} from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import HeaderNavigation from "./components/HeaderNavigation";
import Footer from "./components/Footer";

// Lazy load page components
const Home = React.lazy(() => import("./pages/home"));
const Mission = React.lazy(() => import("./pages/mission"));
const Leaders = React.lazy(() => import("./pages/leaders"));
const Gallery = React.lazy(() => import("./pages/gallery"));
const Blog = React.lazy(() => import("./pages/blog"));
const NotFound = React.lazy(() => import("./pages/404"));
const Privacy = React.lazy(() => import("./pages/privacy"));
const Terms = React.lazy(() => import("./pages/terms"));

function App() {
    return (
        <BrowserRouter>
            <HeaderNavigation/>
            {/* Suspense fallback is displayed while components are loading */}
            <Suspense fallback={<div className="loading-placeholder">Loading...</div>}>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/mission" element={<Mission/>}/>
                    <Route path="/leaders" element={<Leaders/>}/>
                    <Route path="/gallery" element={<Gallery/>}/>
                    <Route path="/blog" element={<Blog/>}/>
                    <Route path="/privacy-policy" element={<Privacy/>}/>
                    <Route path="/terms-of-use" element={<Terms/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </Suspense>
            <Footer/>
        </BrowserRouter>
    );
}

export default App;
